import { useEffect, useRef, useState } from 'react'
import DataTable from 'react-data-table-component';
import { FaEdit } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGetOperatorProfileQuery } from '../../redux/api/profileApi/profileApi';
import { selectAuth, selectBranchId, setActiveTab } from '../../redux/features/authSlice';
import { IAuthUser } from '../../redux/features/authSlice/authSlice.types';
import jwt_decode from 'jwt-decode';
import CustomLoading from '../../components/CustomLoading';
import CustomModal from '../../components/CustomModal';
import * as Yup from 'yup';
import { useFormik } from "formik";
import { useGetRiderListQuery } from '../../redux/api/riderApi/riderApi';
import { useGetPickupRequestListQuery, useUpdatePickupRequestMutation } from '../../redux/api/pickupApi/pickupApi';
import { useCreateParcelMutation } from '../../redux/api/parcelApi/parcelApi';
import { useGetDistrictListQuery } from '../../redux/api/districtApi/districtApi';
import { useGetUpazilaListQuery } from '../../redux/api/upazilaApi/upazilaApi';
import { useGetRoadListQuery } from '../../redux/api/roadApi/roadApi';
import CustomInput from '../../components/CustomInput';
import CustomDropDownList from '../../components/CustomDropDownList';
import { useOnClickOutside } from 'usehooks-ts';
import { useGetMerchantListQuery } from '../../redux/api/merchantApi/merchantApi';

const statusColor = {
    Stored: "bg-[#0cba06]/10 text-[#0cba06]",
    Requested: "bg-[#baa506]/10 text-[#baa506]",
    Accepted: "bg-[#06bab4]/10 text-[#06bab4]",
};

const PickupRequestList = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const { data: profileData, isLoading: profileLoading } = useGetOperatorProfileQuery(authData?.id);
    const permissions: string[] = profileData?.permissions ? JSON.parse(profileData?.permissions) : [];
    const branch_id = useSelector(selectBranchId);
    const { data: pickupRequestList, isLoading: pickupParceLoading } = useGetPickupRequestListQuery(
        branch_id
    );
    const [riderAssignModal, setRiderAssignModal] = useState(false);
    const [riderAlreadyAssignModal, setRiderAlreadyAssignModal] = useState(false);
    const [storedModal, setStoredModal] = useState(false);
    const [riderInfo, setRiderInfo] = useState(null);
    const { data: riderList, isLoading: riderListLoading } = useGetRiderListQuery(branch_id);
    const [assignPickupRider, pickupRiderAssignResult] = useUpdatePickupRequestMutation();
    const [showModal, setShowModal] = useState(false);
    const [createParcel, createResult] = useCreateParcelMutation();
    const { data: districtList, isLoading: districtLoading } =
        useGetDistrictListQuery(undefined);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedThana, setSelectedThana] = useState("");
    const [deliveryFee, setDeliveryFee] = useState(0);
    const { data: upazilaList, isLoading: upazilaLoading } =
        useGetUpazilaListQuery(selectedDistrict);
    const { data: roadList, isLoading: roadLoading } =
        useGetRoadListQuery(selectedThana);
    const { data: merchantList, isLoading: merchantListLoading } = useGetMerchantListQuery(
        branch_id
    );
    const [showDropDown, setShowDropDown] = useState(false);
    const dropDownRef = useRef<HTMLUListElement>();

    useOnClickOutside(dropDownRef, () => setShowDropDown(false));

    const codFee = 0;
    const discount = 0;
    const promoDiscount = 0;
    const additionalCharge = 0;
    const compensationCost = 0;

    const parcelListValidationSchema = Yup.object().shape({
        customername: Yup.string().required("Customer name is required"),
        customercontactnumber: Yup.string().required(
            "Customer contact number is required"
        ),
        merchant_id: Yup.string().required(
            "Merchant is required"
        ),
        deliverydistrict: Yup.string().required("Delivery division is required"),
        deliverythana: Yup.string().required("Delivery thana/upazila is required"),
        deliveryroad: Yup.string().required("Delivery road is required"),
        deliveryaddress: Yup.string().required("Delivery address is required"),
        pickupaddress: Yup.string().required("Pickup address is required"),
        quantity: Yup.number().required("Quantity is required"),
        orderid: Yup.string().required("Order ID is required"),
        productcostamount: Yup.string().required("Amount is required"),
        weightpackage: Yup.number()
            .required("Package weight is required")
            .min(0.1, "Weight must be greater than 0")
            .max(10, "Weight must be less than 10"),
        // deliveryoption: Yup.string().required("Delivery option is required"),
        pickupdate: Yup.string().required("Pickup date is required"),
        deliverydate: Yup.string().required("Delivery date is required"),
        // destinatedbranch: Yup.string().required("Destinated branch is required"),
    });

    const parcelListInitialValues = {
        customername: "",
        merchant_id: "",
        customercontactnumber: "",
        deliverydistrict: "",
        deliverythana: "",
        deliveryroad: "",
        deliveryaddress: "",
        pickupaddress: "",
        quantity: "",
        orderid: "",
        productcostamount: '0',
        weightpackage: "",
        // deliveryoption: "Cash On Delivery",
        pickupdate: "",
        deliverydate: "",
        // destinatedbranch: "",
        itemdescriptions: "",
        deliveryinstructions: "",
    };

    const formik = useFormik({
        initialValues: parcelListInitialValues,
        validationSchema: parcelListValidationSchema,
        onSubmit: async (values, { resetForm }) => {
            const data = {
                merchant_id: values?.merchant_id,
                order_id: values?.orderid,
                i_branch_id: branch_id,
                // d_branch_id: branchList?.filter(
                //     (branch) => branch?.name === values?.destinatedbranch
                // )[0]?.id,
                pickup_location: values?.pickupaddress,
                pickup_date: values?.pickupdate,
                delivery_date: values?.deliverydate,
                customer_name: values?.customername,
                customer_phone: values?.customercontactnumber,
                customer_district: values?.deliverydistrict,
                customer_upazila: values?.deliverythana,
                customer_road: values?.deliveryroad,
                customer_address: values?.deliveryaddress,
                collect_amount: parseInt(values?.productcostamount) + deliveryFee,
                product_cost_amount: values?.productcostamount,
                delivery_fees: deliveryFee,
                cod_fees: codFee,
                discount: discount,
                promo_discount: promoDiscount,
                additional_charge: additionalCharge,
                compensation_cost: compensationCost,
                weight: values?.weightpackage,
                quantity: values?.quantity,
                item_description: values?.itemdescriptions,
                delivery_instruction: values?.deliveryinstructions,
            };
            try {
                await createParcel(data).unwrap();
                toast.success("Parcel created successfully!");
                resetForm();
                setShowModal(false);
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    const {
        handleSubmit,
        values,
        touched,
        errors,
        setFieldValue,
        handleBlur,
        resetForm,
    } = formik;

    useEffect(() => {
        if (parseInt(values?.weightpackage) > 2) {
            setDeliveryFee(60 + (parseInt(values?.weightpackage) - 2) * 10);
        }

        if (
            parseInt(values?.weightpackage) >= 1 &&
            parseInt(values?.weightpackage) <= 2
        ) {
            setDeliveryFee(60);
        }
    }, [values?.weightpackage]);

    const validationSchema = Yup.object().shape({
        rider: Yup.string().required("Rider is required"),
    });

    const initialValues = {
        rider: "",
        inside: "",
    };

    const riderFormik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const data = {
                rider_id: values?.rider,
            };
            try {
                await assignPickupRider({ data, id: riderInfo?.id }).unwrap();
                toast.success("Rider Assigned Successfully!");
                resetForm();
                setRiderAssignModal(false);
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    const handleCancelRider = async () => {
        try {
            toast.info("API is not available!");
        } catch (error) {
            console.log(error);
            toast.error(error?.data?.message || "Something went wrong!");
        }
    }

    const handleStored = async () => {
        const data = {
            status: "Stored",
        }
        try {
            await assignPickupRider({ data, id: riderInfo?.id }).unwrap();
            toast.success("Parcel stored successfully!");
            setStoredModal(false);
        } catch (error) {
            console.log(error);
            toast.error(error?.data?.message || "Something went wrong!");
        }
    }

    const columns = [
        {
            name: "Address",
            selector: (row) => row?.pickup_location,
            sortable: true,
        },
        {
            name: "Weight",
            selector: (row) => row?.weight,
            sortable: true,
        },
        {
            name: "No of Parcel",
            selector: (row) => row?.parcel_count,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => (
                <div
                    className={`py-1 w-20 text-center rounded ${statusColor[row?.status]
                        }`}
                >
                    {row?.status}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Assign Rider",
            cell: (row) => (
                <div
                    onClick={() => {
                        if (permissions?.includes("AcceptPickupRequest") || profileData?.isManager) {
                            setRiderInfo(row);
                            if (row?.status === "Accepted") {
                                setStoredModal(true);
                            } else if (row?.status === "Stored") {
                                toast.info("This parcel is already stored!")
                            } else if (row?.rider !== null) {
                                setRiderAlreadyAssignModal(true);
                            } else {
                                setRiderAssignModal(true);
                            }
                        } else {
                            toast.info('You have not permitted!')
                        }

                    }}
                    className={`flex flex-row gap-2 items-center justify-center py-1 w-20 text-center rounded border bg-secondary/10 border-secondary text-secondary cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white`}
                >
                    <FaEdit /> Edit
                </div>
            ),
        },
    ];

    useEffect(() => {
        if (pathname === "/pickup-request-list") {
            dispatch(setActiveTab("Pickup Request List"));
        }
    }, [dispatch, pathname]);
    return (
        <div className="w-full flex flex-col gap-10">
            <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex flex-row gap-10">
                <div className="flex flex-col justify-between w-full gap-4">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <div className="text-2xl font-bold text-text_1">Pickup Request List</div>
                        <div
                            onClick={() => {
                                if (permissions?.includes("CreateParcel") || profileData?.isManager) {
                                    setShowModal(true);
                                } else {
                                    toast.info("You have not permitted!");
                                }
                            }}
                            className="py-2 px-3 border border-secondary text-secondary rounded bg-secondary/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white"
                        >
                            Add Parcel
                        </div>
                    </div>
                    <div className="flex flex-row gap-4 items-center w-full">
                        <div className='text-text_2 italic text-lg'>A list of requests for arranging pickups</div>
                    </div>
                </div>
                <div className="h-40 hidden lg:flex">
                    <img
                        src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                        alt="self drive"
                        className="h-full w-full"
                    />
                </div>
            </div>
            <div className="overflow-x-auto bg-white shadow-lg rounded-lg p-2">
                <DataTable
                    columns={columns}
                    data={pickupRequestList}
                    pagination
                    persistTableHead
                    highlightOnHover
                />
            </div>

            <CustomModal
                showModal={riderAssignModal}
                setShowModal={setRiderAssignModal}
                submitButton={true}
                handleSubmit={riderFormik?.handleSubmit}
                title={'Assign Rider'}
                className="md:min-w-[60%] lg:min-w-[40vw] xl:min-w-[29vw]"
            >
                <form
                    onSubmit={riderFormik?.handleSubmit}
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <div className="flex flex-col sm:flex-row gap-5">
                        <div className="w-full">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                SELECT RIDER
                            </div>
                            <select
                                id="rider"
                                onBlur={riderFormik?.handleBlur}
                                value={riderFormik?.values.rider}
                                onChange={(e) => riderFormik?.setFieldValue("rider", e.target.value)}
                                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                            >
                                <option value="">Select a rider</option>
                                {riderList?.map((data, index) => {
                                    return (
                                        <option key={index} value={data?.id}>
                                            {data?.name}
                                        </option>
                                    );
                                })}
                            </select>
                            {riderFormik?.touched.rider && riderFormik?.errors.rider ? (
                                <span className="text-error text-sm mt-1">
                                    {riderFormik?.errors.rider}
                                </span>
                            ) : null}
                        </div>
                        <div className="w-full">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                SELECT INSIDE OR OUTSIDE CITY
                            </div>
                            <select
                                id="status"
                                value={riderFormik?.values.inside}
                                onChange={(e) => riderFormik?.setFieldValue('inside', e.target.value)}
                                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                            >
                                <option value="InSide">
                                    Inside City
                                </option>
                                <option value="OutSide">
                                    Outside City
                                </option>
                            </select>
                        </div>
                    </div>
                </form>
            </CustomModal>

            <CustomModal
                showModal={riderAlreadyAssignModal}
                setShowModal={setRiderAlreadyAssignModal}
                handleSubmit={handleCancelRider}
                submitButton={true}
                submitButtonText='Cancel Rider'
                warning={true}
                title={"Rider Information"}
                className="sm:min-w-[70%] md:min-w-[60%] lg:min-w-[25vw] xl:min-w-[20vw]"
            >
                <div
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <div className="text-text_2">A rider has been assigned to pick up your parcel.</div>
                    <div className="text-text_1 font-semibold text-xl">Contact with rider to get estimated pick up time.</div>
                    <div
                        className="flex flex-row items-center mt-5 gap-4"
                    >
                        <div
                            className="h-28 w-3h-28 rounded-lg overflow-hidden"
                        >
                            <img
                                src={
                                    riderInfo?.rider?.image ||
                                    "https://i.ibb.co/8MgR8kC/images.png"
                                }
                                style={{ height: "100%", objectFit: "cover" }}
                                className="img-fluid"
                                alt=""
                            />
                        </div>
                        <div className="flex flex-col gap-2">
                            <div className="bg-stroke_1 shadow text-text_2 font-semibold text-xl py-2 px-3 rounded">Name: {riderInfo?.rider?.name}</div>
                            <div className="bg-stroke_1 shadow text-text_2 font-semibold text-xl py-2 px-3 rounded">Phone: {riderInfo?.rider?.contact_number}</div>
                        </div>
                    </div>
                </div>
            </CustomModal>

            <CustomModal
                showModal={storedModal}
                setShowModal={setStoredModal}
                handleSubmit={handleStored}
                submitButton={true}
                submitButtonText='Yes'
                closeButtonText='No'
                title={"Change Pickup Request Status"}
                className="md:min-w-[60%] lg:min-w-[40vw] xl:min-w-[29vw]"
            >
                <div className="text-xl font-semibold text-primary ">Is the parcel stored ?</div>
            </CustomModal>

            <CustomModal
                showModal={showModal}
                setShowModal={setShowModal}
                submitButton={true}
                handleSubmit={handleSubmit}
                title={"Create New Parcel"}
            >
                <form
                    onSubmit={handleSubmit}
                    className="w-full flex flex-col gap-2 mt-5 min-w-[70%]"
                >
                    <div className="text-2xl font-bold text-text_1 mb-2">
                        Customer Information
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomInput
                            label="CUSTOMER NAME"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.customername}
                            touched={touched.customername}
                            error={errors.customername}
                            handleBlur={handleBlur}
                        />
                        <CustomInput
                            label="CUSTOMER CONTACT NUMBER"
                            type="number"
                            setFieldValue={setFieldValue}
                            value={values.customercontactnumber}
                            touched={touched.customercontactnumber}
                            error={errors.customercontactnumber}
                            handleBlur={handleBlur}
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomDropDownList
                            list={districtList}
                            label="DELIVERY DISTRICT"
                            selectTitle="Select a district"
                            onChange={(e) => {
                                setFieldValue("deliverydistrict", e.target.value);
                                setSelectedDistrict(
                                    districtList?.filter(
                                        (item) => item?.name === e.target.value
                                    )[0]?.id
                                );
                            }}
                            value={values.deliverydistrict}
                            touched={touched.deliverydistrict}
                            error={errors.deliverydistrict}
                            handleBlur={handleBlur}
                            required
                        />
                        <CustomDropDownList
                            list={upazilaList}
                            label="DELIVERY THANA"
                            selectTitle="Select a thana/upazila"
                            onChange={(e) => {
                                setFieldValue("deliverythana", e.target.value);
                                setSelectedThana(
                                    upazilaList?.filter(
                                        (item) => item?.name === e.target.value
                                    )[0]?.id
                                );
                            }}
                            value={values.deliverythana}
                            touched={touched.deliverythana}
                            error={errors.deliverythana}
                            handleBlur={handleBlur}
                            required
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <div className="w-full my-2">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                DELIVERY ROAD
                            </div>
                            <div className="relative">
                                <input
                                    id={"deliveryroad"}
                                    value={values.deliveryroad}
                                    onChange={(e) =>
                                        setFieldValue("deliveryroad", e.target.value)
                                    }
                                    className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                                    onBlur={handleBlur}
                                    onFocus={() => setShowDropDown(true)}
                                />
                                {showDropDown && (
                                    <ul
                                        ref={dropDownRef}
                                        className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-lg shadow-md"
                                    >
                                        {roadList?.map(
                                            (road: { id: number; name: string }, index: number) => (
                                                <li
                                                    key={index}
                                                    className="p-2 cursor-pointer"
                                                    onClick={() => {
                                                        setFieldValue("deliveryroad", road?.name);
                                                        setShowDropDown(false);
                                                    }}
                                                >
                                                    {road?.name}
                                                </li>
                                            )
                                        )}
                                    </ul>
                                )}
                            </div>

                            {touched.deliveryroad && errors.deliveryroad ? (
                                <span className="text-error text-sm mt-1">
                                    {errors.deliveryroad}
                                </span>
                            ) : null}
                        </div>
                        <CustomInput
                            label="DELIVERY ADDRESS"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.deliveryaddress}
                            touched={touched.deliveryaddress}
                            error={errors.deliveryaddress}
                            handleBlur={handleBlur}
                        />
                    </div>
                    <div className="text-2xl font-bold text-text_1 my-2">
                        Parcel Information
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <div className="w-full my-2">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                SELECT MERCHANT
                            </div>
                            <select
                                id="merchant_id"
                                value={values.merchant_id}
                                onChange={(e) => {
                                    setFieldValue('merchant_id', e.target.value);
                                }}
                                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                            >
                                <option value="">Select a store</option>
                                {merchantList?.map((data, index) => {
                                    return (
                                        <option key={index} value={data?.id}>
                                            {data?.name}
                                        </option>
                                    );
                                })}
                            </select>
                            {touched.merchant_id && errors.merchant_id ? (
                                <span className="text-error text-sm mt-1">
                                    {errors.merchant_id}
                                </span>
                            ) : null}
                        </div>
                        <CustomInput
                            label="PICKUP ADDRESS"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.pickupaddress}
                            touched={touched.pickupaddress}
                            error={errors.pickupaddress}
                            handleBlur={handleBlur}
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomInput
                            label="QUANTITY"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.quantity}
                            touched={touched.quantity}
                            error={errors.quantity}
                            handleBlur={handleBlur}
                        />
                        <CustomInput
                            label="ORDER ID"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.orderid}
                            touched={touched.orderid}
                            error={errors.orderid}
                            handleBlur={handleBlur}
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomInput
                            label="PRODUCT COST AMOUNT"
                            type="number"
                            setFieldValue={setFieldValue}
                            value={values.productcostamount}
                            touched={touched.productcostamount}
                            error={errors.productcostamount}
                            handleBlur={handleBlur}
                        />
                        <CustomInput
                            label="WEIGHT PACKAGE"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.weightpackage}
                            touched={touched.weightpackage}
                            error={errors.weightpackage}
                            handleBlur={handleBlur}
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        {/* <CustomDropDownList
                            list={deliveryOptions}
                            label="DELIVERY OPTION"
                            selectTitle="Select a delivery option"
                            onChange={(e) => setFieldValue("deliveryoption", e.target.value)}
                            value={values.deliveryoption}
                            touched={touched.deliveryoption}
                            error={errors.deliveryoption}
                            handleBlur={handleBlur}
                            required
                        /> */}
                        <div className="w-full my-2">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                PICKUP DATE
                            </div>
                            <input
                                type="date"
                                id="start"
                                name="trip-start"
                                value={values.pickupdate}
                                onChange={(e) => setFieldValue("pickupdate", e.target.value)}
                                className="w-full border-2 p-2 rounded-lg focus:border-secondary focus:outline-none"
                            />
                            {touched.pickupdate && errors.pickupdate ? (
                                <span className="text-error text-sm mt-1">
                                    {errors.pickupdate}
                                </span>
                            ) : null}
                        </div>

                        <div className="w-full my-2">
                            <div className="text-text_2 text-md font-semibold mb-2">
                                DELIVERY DATE
                            </div>
                            <input
                                type="date"
                                id="start"
                                name="trip-start"
                                value={values.deliverydate}
                                onChange={(e) => setFieldValue("deliverydate", e.target.value)}
                                className="w-full border-2 p-2 rounded-lg focus:border-secondary focus:outline-none"
                            />
                            {touched.deliverydate && errors.deliverydate ? (
                                <span className="text-error text-sm mt-1">
                                    {errors.deliverydate}
                                </span>
                            ) : null}
                        </div>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-5">
                        <CustomInput
                            label="ITEM DESCRIPTIONS"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.itemdescriptions}
                            touched={touched.itemdescriptions}
                            error={errors.itemdescriptions}
                            handleBlur={handleBlur}
                        />
                        <CustomInput
                            label="DELIVERY INSTRUCTIONS"
                            type="text"
                            setFieldValue={setFieldValue}
                            value={values.deliveryinstructions}
                            touched={touched.deliveryinstructions}
                            error={errors.deliveryinstructions}
                            handleBlur={handleBlur}
                        />
                    </div>
                </form>
                <div className="bg-[#F4F4F4] rounded-lg px-2 py-3 mt-4 flex flex-col gap-2">
                    <div className="text-lg text-text_1 font-bold m-2">
                        Cost Of Delivary
                    </div>
                    <div className="bg-white rounded-lg p-3 flex justify-between items-center text-md font-semibold text-text_1">
                        <div>Product Cost Amount</div>
                        <div>৳ {values?.productcostamount}</div>
                    </div>
                    <div className="bg-white rounded-lg p-3 flex justify-between items-center text-md font-semibold text-text_1">
                        <div>Delivary Fee</div>
                        <div>৳ {deliveryFee}</div>
                    </div>
                    <div className="bg-white rounded-lg p-3 flex justify-between items-center text-md font-semibold text-text_1">
                        <div>COD Fee</div>
                        <div>৳ {codFee}</div>
                    </div>
                    <div className="bg-white rounded-lg p-3 flex justify-between items-center text-md font-semibold text-text_1">
                        <div>Discount</div>
                        <div>৳ {discount}</div>
                    </div>
                    <div className="bg-white rounded-lg p-3 flex justify-between items-center text-md font-semibold text-text_1">
                        <div>Promo Discount</div>
                        <div>৳ {promoDiscount}</div>
                    </div>
                    <div className="bg-white rounded-lg p-3 flex justify-between items-center text-md font-semibold text-text_1">
                        <div>Additional Charge</div>
                        <div>৳ {additionalCharge}</div>
                    </div>
                    <div className="bg-white rounded-lg p-3 flex justify-between items-center text-md font-semibold text-text_1">
                        <div>Compensation Cost</div>
                        <div>৳ {compensationCost}</div>
                    </div>
                    <div className="border-b-2 border-secondary mt-5" />
                    <div className="p-3 flex justify-between items-center text-lg font-semibold text-text_1">
                        <div>Total Amount</div>
                        <div>
                            ৳{" "}
                            {parseInt(values.productcostamount) +
                                deliveryFee +
                                codFee -
                                discount -
                                promoDiscount +
                                additionalCharge +
                                compensationCost}
                        </div>
                    </div>
                </div>
            </CustomModal>

            {(pickupParceLoading || riderListLoading || pickupRiderAssignResult.isLoading || profileLoading ||
                profileLoading ||
                districtLoading ||
                upazilaLoading ||
                roadLoading ||
                createResult.isLoading || merchantListLoading) && <CustomLoading />}
        </div>
    )
}

export default PickupRequestList